import React from 'react';
import './BrandTopSubHeaderComponent.styles.scss';

const BrandTopSubHeaderComponent = ({ children, className }) => {
  return (
    <div className={`sub_header ${className}`}>
      {children}
    </div>
  );
};

export default BrandTopSubHeaderComponent;
